import React from 'react';
import { X } from 'lucide-react';

export default function CreateCollectionModal({
  show,
  onClose,
  t,
  form,
  setForm,
  onSubmit
}) {
  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-50 px-4">
      <div className="bg-[#0F1F1A] border border-[#C9A962]/20 rounded-2xl p-6 w-full max-w-md" data-testid="create-collection-modal">
        <div className="flex items-center justify-between mb-5">
          <h3 className="text-[#F5F0E6] font-bold text-lg" style={{ fontFamily: 'Cinzel, serif' }}>
            {t('collections.create')}
          </h3>
          <button onClick={onClose} className="text-[#A8B5AE] hover:text-[#F5F0E6]">
            <X size={20} />
          </button>
        </div>
        
        <form onSubmit={onSubmit} className="space-y-4">
          <input 
            value={form.name} 
            onChange={e => setForm(f => ({ ...f, name: e.target.value }))} 
            required
            placeholder={t('collectionsShared.collection_name_placeholder')}
            className="w-full bg-[#0A1612] border border-[#C9A962]/20 rounded-xl px-4 py-3 text-[#F5F0E6] text-sm outline-none focus:border-[#C9A962] placeholder:text-[#A8B5AE]/50"
            data-testid="collection-name-input"
          />
          
          <textarea 
            value={form.description} 
            onChange={e => setForm(f => ({ ...f, description: e.target.value }))} 
            rows={2}
            placeholder={t('collectionsShared.collection_description_placeholder')}
            className="w-full bg-[#0A1612] border border-[#C9A962]/20 rounded-xl px-4 py-3 text-[#F5F0E6] text-sm outline-none focus:border-[#C9A962] resize-none placeholder:text-[#A8B5AE]/50"
            data-testid="collection-desc-input"
          />
          
          <select 
            value={form.tcg_type} 
            onChange={e => setForm(f => ({ ...f, tcg_type: e.target.value }))}
            className="w-full bg-[#0A1612] border border-[#C9A962]/20 rounded-xl px-4 py-3 text-[#F5F0E6] text-sm outline-none focus:border-[#C9A962]"
            data-testid="tcg-type-select"
          >
            <option value="mixed">{t('collectionsShared.mixed')}</option>
            <option value="pokemon">Pokémon</option>
            <option value="magic">Magic: The Gathering</option>
            <option value="yugioh">Yu-Gi-Oh!</option>
            <option value="onepiece">One Piece TCG</option>
            <option value="riftbound">Riftbound (LoL TCG)</option>
          </select>
          
          <label className="flex items-center gap-3 cursor-pointer">
            <input 
              type="checkbox" 
              checked={form.is_public} 
              onChange={e => setForm(f => ({ ...f, is_public: e.target.checked }))}
              className="w-4 h-4 rounded accent-[#C9A962]" 
              data-testid="public-checkbox"
            />
            <span className="text-[#A8B5AE] text-sm">
              {t('collectionsShared.public_collection_help')}
            </span>
          </label>
          
          <button type="submit" className="w-full btn-primary py-3 text-sm" data-testid="submit-collection-btn">
            {t('collectionsShared.create_collection')}
          </button>
        </form>
      </div>
    </div>
  );
}
